import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Column } from '@/components/layout'
import RecaptchaTerms from '@/components/common/RecaptchaTerms'

import styles from './SignUp.module.scss'

export default function SignUpLayout({
  split = true,
  children,
  sideContent,
  formHolderClassName,
  withWrapperBackground,
  ...rest
}) {
  useEffect(() => {
    if (split) {
      const body = document.querySelector('body')
      body?.classList.add('sign-up-split')

      return () => body?.classList.remove('sign-up-split')
    }
    return undefined
  }, [split])
  return (
    <div className={cx(split ? styles.split : styles.wrapper, withWrapperBackground && styles.wrapperBackground)}>
      <Column
        className={cx(styles.formHolder, formHolderClassName)}
        justifyCenter={!split}
        size={split ? 40 : undefined}
        {...rest}
      >
        {children}
        <RecaptchaTerms textProps={{ center: true }} />
      </Column>
      {split && sideContent && (
        <Column justifyCenter size={60}>
          {sideContent}
        </Column>
      )}
    </div>
  )
}

SignUpLayout.propTypes = {
  split: PropTypes.bool,
  children: PropTypes.node.isRequired,
  sideContent: PropTypes.node,
  formHolderClassName: PropTypes.string,
  withWrapperBackground: PropTypes.bool,
}
